import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "@mui/material";
import { Box } from "../Box/index.js";
import { IconButton } from "../IconButton/index.js";
const ButtonWithoutForwardRef = ({ size = 'medium', variant = 'primary', danger = false, children, StartIcon, EndIcon, Badge, buttonType: initButtonType, component, ...props }, ref)=>{
    const defaultButtonType = children ? 'button' : 'icon';
    const buttonType = initButtonType || defaultButtonType;
    const variantProps = getVariantProps(danger, variant);
    const hasIcons = !!StartIcon || !!EndIcon;
    const renderIconButton = 'icon' === buttonType && hasIcons && 'primary' !== variant;
    if (renderIconButton) return /*#__PURE__*/ jsxs(IconButton, {
        ...props,
        component: component ?? 'button',
        variant: variant,
        size: size,
        danger: danger,
        Badge: Badge,
        ref: ref,
        children: [
            StartIcon,
            EndIcon
        ]
    });
    return /*#__PURE__*/ jsxs(Button, {
        ...props,
        ...variantProps,
        component: component ?? 'button',
        startIcon: StartIcon,
        endIcon: EndIcon,
        size: size,
        ref: ref,
        children: [
            children,
            Badge && /*#__PURE__*/ jsx(Box, {
                sx: {
                    position: 'absolute',
                    top: '-6px',
                    right: '-4px'
                },
                children: Badge
            })
        ]
    });
};
const Button_Button = /*#__PURE__*/ forwardRef(ButtonWithoutForwardRef);
function getVariantProps(danger, variant) {
    const variantMap = {
        primary: {
            variant: 'contained',
            color: danger ? 'error' : 'primary'
        },
        secondary: {
            variant: 'outlined',
            color: danger ? 'error' : 'secondary'
        },
        tertiary: {
            variant: 'text',
            color: danger ? 'error' : 'primary'
        }
    };
    return variantMap[variant];
}
export { Button_Button as Button };

//# sourceMappingURL=Button.js.map